import {getImageUrl, getVideoUrl, Sizes} from '@cohort/shared/utils/media';
import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import type {PerkWDto} from '@cohort/wallet-schemas/perk';
import React, {Fragment} from 'react';

interface PerkVisualProps {
  perk: PerkWDto;
}

export const PerkVisual: React.FC<PerkVisualProps> = ({perk}): React.ReactElement => {
  const {hasDarkBg} = useThemeContext();

  if (perk.bannerFileKey === null && perk.thumbnailFileKey === null) {
    return <Fragment />;
  }

  const style = classNames(
    'rounded-xl object-fit max-h-full w-full aspect-auto border',
    hasDarkBg ? 'border-white/20' : 'border-black/20'
  );

  if (perk.videoFileKey !== null && perk.thumbnailFileKey !== null) {
    return (
      <video
        data-testid="perk-visual-video"
        controls={false}
        disablePictureInPicture
        disableRemotePlayback
        autoPlay
        playsInline
        webkit-playsinline="true"
        loop
        muted
        className={style}
      >
        <source
          src={getVideoUrl(import.meta.env.COHORT_ENV, perk.videoFileKey, {
            h: Sizes.M,
            w: Sizes.M,
          })}
        />
        <img
          data-testid="perk-visual-video-thumbnail-image"
          title="perk video thumbnail"
          className={style}
          src={getImageUrl(import.meta.env.COHORT_ENV, perk.thumbnailFileKey, {
            h: Sizes.L,
            w: Sizes.L,
          })}
        />
      </video>
    );
  } else if (perk.bannerFileKey !== null) {
    return (
      <img
        data-testid="perk-visual-image"
        title="perk"
        className={style}
        src={getImageUrl(import.meta.env.COHORT_ENV, perk.bannerFileKey, {
          h: Sizes.L,
          w: Sizes.L,
        })}
      />
    );
  }
  return <Fragment />;
};
